(() => {
  'use strict';
  const normalize = value => {
    const text = String(value || '').toLowerCase().replace(/c\s*\/\s*c|hulafstand/g, '').trim();
    const match = text.match(/^(\d+(?:[.,]\d+)?)\s*(mm|cm)?$/);
    return match ? String(Number(match[1].replace(',', '.')) * (match[2] === 'cm' ? 10 : 1)) : text;
  };
  const init = root => {
    if (root.dataset.chdLinkedReady) return;
    root.dataset.chdLinkedReady = 'true';
    const form = root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    let product;
    try { product = JSON.parse(root.querySelector('[data-product-json]').textContent).product; } catch (_) { return; }
    const options = product.options || [];
    const index = options.findIndex(option => /hulafstand|c\/c|diameter|størrelse|længde fra center/i.test(option.name || option));
    const links = [...root.querySelectorAll('[data-chd-linked-sizes]')];
    const quantity = form.querySelector('[name="quantity"]');
    const params = new URLSearchParams(location.search);
    const requestedQuantity = Number(params.get('chd_qty'));
    if (quantity && Number.isInteger(requestedQuantity) && requestedQuantity > 0) {
      quantity.value = String(requestedQuantity);
      quantity.dispatchEvent(new Event('change', { bubbles:true }));
    }
    const notice = root.querySelector('[data-chd-size-transfer-notice]');
    const current = () => product.variants.find(variant => String(variant.id) === form.querySelector('[name="id"]')?.value);
    let needsChoice = params.get('chd_choose_size') === '1';
    // A linked product can have just one variant (and no selector). Give the
    // customer an explicit choice there too, rather than trapping checkout.
    if (needsChoice && notice && !form.querySelector('.product-form__single-selector') && current()) {
      const confirm = document.createElement('button');
      confirm.type = 'button'; confirm.className = 'chd-handle-size-select__trigger';
      confirm.textContent = current().title === 'Default Title' ? product.title : current().title;
      confirm.addEventListener('click', () => { needsChoice = false; sync(); root.querySelector('.product-form__add-button')?.focus(); });
      notice.append(confirm);
    }
    const guard = event => {
      if (!needsChoice) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (notice) notice.hidden = false;
      root.querySelector('.chd-handle-size-select__trigger, .product-form__single-selector')?.focus();
    };
    form.addEventListener('submit', guard, true);
    const sync = () => {
      const selected = current();
      links.forEach(link => {
        const url = new URL(link.dataset.chdLinkedBase || link.href, location.origin);
        link.dataset.chdLinkedBase = url.origin + url.pathname;
        url.search = '';
        if (index >= 0 && selected) {
          let variants;
          try { variants = JSON.parse(link.dataset.chdLinkedSizes); } catch (_) { return; }
          const sourceSize = selected.options?.[index] || selected['option' + (index + 1)];
          const matches = variants.filter(variant => normalize(variant.size) === normalize(sourceSize));
          if (matches.length === 1) url.searchParams.set('variant', matches[0].id);
          else { url.searchParams.set('chd_choose_size', '1'); url.searchParams.set('chd_size', sourceSize); }
        }
        if (quantity && Number(quantity.value) > 1) url.searchParams.set('chd_qty', quantity.value);
        link.href = url.pathname + url.search;
      });
      root.dataset.chdNeedsSize = String(needsChoice);
      if (notice) notice.hidden = !needsChoice;
    };
    // The theme emits variant:changed before updating its master select.
    root.addEventListener('variant:changed', () => queueMicrotask(sync));
    form.addEventListener('change', event => {
      if (event.target.matches('.product-form__single-selector')) needsChoice = false;
      queueMicrotask(sync);
    });
    form.addEventListener('input', sync);
    root.addEventListener('click', event => {
      if (event.target.closest('[data-chd-linked-sizes]')) sync();
      if (event.target.closest('.chd-handle-size-select__option')) { needsChoice = false; sync(); }
      if (event.target.closest('.product-form__add-button')) guard(event);
      if (event.target.closest('[data-action*="picker-quantity"]')) queueMicrotask(sync);
    }, true);
    sync();
    const rail = root.querySelector('.chd-design-picker__grid');
    const active = rail?.querySelector('[aria-current="page"]');
    if (rail && active && matchMedia('(max-width:767px)').matches) {
      rail.scrollLeft = Math.max(0, active.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + active.clientWidth / 2);
    }
  };
  const start = () => document.querySelectorAll('.chd-pdp').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
